import { HttpClient } from "@angular/common/http";
import {Observable} from "rxjs/internal/Observable";
import {
  AssessmentWithSeverityAction
} from "../../models/assessment-with-severity-action/assessment-with-severity-action.model";
import {UrlBuilder} from "../../models/frontend_entities/UrlBuilder";
import Constants from "../../Constants";
import {AppData} from "../AppData";
import {Injectable} from "@angular/core";


@Injectable()
export class AssessmentWithSeverityActionRequestService {

  //region CONSTRUCTOR
  constructor(
    private data: AppData,
    private http: HttpClient
  ) {}
  //endregion

  //region GET
  public getInheritedAssessmentsWithSeverityActionForChecklistTemplateVersion(
    checklistTemplateVersionId: string
  ): Observable<AssessmentWithSeverityAction[]> {
    const url: string =
      new UrlBuilder(Constants.URLS.assessmentWithSeverityAction.inheritedForChecklistTemplateVersion
        .replace("{checklistTemplateVersionId}", checklistTemplateVersionId)
      )
        .param('accessMode', this.data.getAccessMode())
        .build();

    return this.http.get<AssessmentWithSeverityAction[]>(url);
  }

  public getAssessmentsWithSeverityActionForChecklistTemplateVersion(
    checklistTemplateVersionId: string
  ): Observable<AssessmentWithSeverityAction[]> {
    const url: string =
      new UrlBuilder(Constants.URLS.assessmentWithSeverityAction.checklistTemplateVersion
        .replace("{checklistTemplateVersionId}", checklistTemplateVersionId)
      )
        .param('accessMode', this.data.getAccessMode())
        .build();

    return this.http.get<AssessmentWithSeverityAction[]>(url);
  }
  //endregion

  //region POST
  public saveAssessmentsWithSeverityActionForChecklistTemplateVersion(
    checklistTemplateVersionId: string,
    assessmentsWithSeverityAction: AssessmentWithSeverityAction[]
  ): Observable<AssessmentWithSeverityAction[]> {
    const url: string =
      new UrlBuilder(Constants.URLS.assessmentWithSeverityAction.checklistTemplateVersion
        .replace("{checklistTemplateVersionId}", checklistTemplateVersionId)
      )
        .param('accessMode', this.data.getAccessMode())
        .build();

    return this.http.post<AssessmentWithSeverityAction[]>(url, assessmentsWithSeverityAction);
  }
  //endregion

  //region DELETE
  public deleteAssessmentsWithSeverityActionOfChecklistTemplateVersion(
    checklistTemplateVersionId: string
  ): Observable<AssessmentWithSeverityAction[]> {
    const url: string =
      new UrlBuilder(Constants.URLS.assessmentWithSeverityAction.checklistTemplateVersion
        .replace("{checklistTemplateVersionId}", checklistTemplateVersionId)
      )
        .param('accessMode', this.data.getAccessMode())
        .build();

    return this.http.delete<AssessmentWithSeverityAction[]>(url);
  }
  //endregion

}
